import React from 'react'
import { Checkbox, Form, Input, Row, Col, DatePicker, Select } from 'antd';
import HmsFormItem from 'components/Form/HmsFormItem';

const FormCheckbox = ({ label, name, required, autoFocus, placeholder, formItemProps, fieldItemProps }) => {
    return (
        <HmsFormItem
            label={label}
            name={name}
            required={required}
            valuePropName='checked'
            {...formItemProps}
        >
            <Checkbox
            autoFocus={autoFocus}
                {...fieldItemProps} />
        </HmsFormItem>
    )
}

export default FormCheckbox